import { useState } from 'react';

import { useIsomorphicLayoutEffect } from './useIsomorphicLayoutEffect';

const QUERY = '(prefers-reduced-motion: reduce)';

export function usePrefersReducedMotion(): boolean {
  // Starts `false` to match SSR markup (no `window` server-side) — reconciled to the real value
  // below, before paint, so there's no visible flash.
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

  useIsomorphicLayoutEffect(() => {
    const mediaQueryList = window.matchMedia(QUERY);
    // Reconcile immediately: if the preference is already `true` at mount, a `change`-event-only
    // listener would never fire (the value isn't changing), leaving the state stuck at `false`.
    setPrefersReducedMotion(mediaQueryList.matches);

    const listener = (event: MediaQueryListEvent) => setPrefersReducedMotion(event.matches);

    mediaQueryList.addEventListener('change', listener);

    return () => mediaQueryList.removeEventListener('change', listener);
  }, []);

  return prefersReducedMotion;
}
